import { render, staticRenderFns } from "./boatHome.vue?vue&type=template&id=1d8f9e20&"
import script from "./boatHome.vue?vue&type=script&lang=js&"
export * from "./boatHome.vue?vue&type=script&lang=js&"
import style0 from "./boatHome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports